"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCTS_PAGINATION_LIMIT_FIRST_PAGE = exports.PRODUCTS_PAGINATION_LIMIT = exports.DEFAULT_EDITORIALS_PATHNAME = void 0;
const DEFAULT_EDITORIALS_PATHNAME = exports.DEFAULT_EDITORIALS_PATHNAME = '/campaigns/editorials';
const PRODUCTS_PAGINATION_LIMIT = exports.PRODUCTS_PAGINATION_LIMIT = 20;
const PRODUCTS_PAGINATION_LIMIT_FIRST_PAGE = exports.PRODUCTS_PAGINATION_LIMIT_FIRST_PAGE = 12;
